(function () {
  const log = (...args) => { if (window.DEBUG_VIR === true) console.log('[VIR]', ...args); };

  const dataEl = document.getElementById('variant-image-data');
  if (!dataEl) return;

  let data;
  try {
    data = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }
  const mediaPositions = data.mediaPositions || {};
  const variantStarts = data.variantStarts || {};
  // Video media (Shopify-hosted + external/YouTube) should show for ALL variants,
  // not be position-range filtered — a video sits last in the gallery, so the range
  // logic would otherwise only reveal it on the final variant. See main-product.liquid.
  const videoIds = new Set((data.videoIds || []).map(String));
  // Variants whose real interior/contents differ from the shared "hero" photos
  // (e.g. a White colorway with a genuine white interior vs. every other color's
  // black interior) opt out of the shared zone entirely via the WhiteNoSharedImages
  // tag — see main-product.liquid. They fall back to only their own owned range.
  const noSharedVariantIds = new Set((data.noSharedVariantIds || []).map(String));

  const sortedVariants = Object.entries(variantStarts)
    .map(([vid, pos]) => ({ vid: String(vid), pos: Number(pos) }))
    .sort((a, b) => a.pos - b.pos);

  const uniqueStarts = [...new Set(sortedVariants.map((v) => v.pos))].sort((a, b) => a - b);
  const variantRanges = {};
  sortedVariants.forEach((v) => {
    const idx = uniqueStarts.indexOf(v.pos);
    variantRanges[v.vid] = {
      start: v.pos,
      end: idx + 1 < uniqueStarts.length ? uniqueStarts[idx + 1] - 1 : Infinity,
    };
  });

  function extractMediaId(value) {
    if (!value) return '';
    const match = String(value).match(/(\d+)$/);
    return match ? match[1] : '';
  }

  function getVariantId() {
    const input = document.querySelector('product-info [name="id"], form[action*="/cart/add"] [name="id"]');
    if (input && input.value) return String(input.value);
    const urlId = new URL(location.href).searchParams.get('variant');
    return urlId ? String(urlId) : '';
  }

  const firstVariantStart = sortedVariants.length > 0 ? sortedVariants[0].pos : Infinity;
  const heroOnly = data.heroOnly === true;
  const heroPosition = Number(data.heroPosition) || 0;
  const variantOwnedPositions = new Set(uniqueStarts);

  function isInRange(mediaId, range, variantId) {
    // Videos are always visible, regardless of the selected variant's range.
    if (videoIds.has(String(mediaId))) return true;
    const pos = mediaPositions[mediaId];
    if (pos === undefined) return true;
    // If this position is a variant's start, variant ownership wins over the
    // hero/shared rule. Otherwise the product hero (= variant 1's featured
    // image, in the common case) would stay visible for every variant.
    if (!variantOwnedPositions.has(pos)) {
      const isSharedZone = (heroPosition && pos === heroPosition) || pos < firstVariantStart;
      if (isSharedZone) {
        if (noSharedVariantIds.has(variantId)) return false;
        return !heroOnly;
      }
    }
    return pos >= range.start && pos <= range.end;
  }

  function getMainSlider() {
    const gallery = document.querySelector('media-gallery');
    if (!gallery) return null;
    return (
      gallery.querySelector('slider-component[id^="GalleryViewer-"]') ||
      gallery.querySelector('slider-component')
    );
  }

  // Sorted by media position (stable across variant changes).
  function getSortedVisibleItems(slider) {
    const items = Array.from(slider.querySelectorAll('li:not(.vir-hidden)'));
    return items.sort((a, b) => {
      const posA = mediaPositions[extractMediaId(a.dataset.mediaId)] || 0;
      const posB = mediaPositions[extractMediaId(b.dataset.mediaId)] || 0;
      return posA - posB;
    });
  }

  // ---------- State ----------
  let targetSlot = null;
  let restoreWindowExpiry = 0; // tryRestoreSlide only fires while now < this
  let originalSetActiveMedia = null;
  let suppressSlideListener = false;

  function initTargetSlotFromActive() {
    if (targetSlot != null) return;
    const slider = getMainSlider();
    if (!slider) return;
    const sorted = getSortedVisibleItems(slider);
    const activeItem = slider.querySelector('.product__media-item.is-active');
    if (activeItem) {
      const idx = sorted.indexOf(activeItem);
      if (idx >= 0) targetSlot = idx + 1;
    }
    log('init targetSlot=', targetSlot);
  }

  // Delegate to Dawn's own setActiveMedia. Always prepend=false:
  // - thumbnail layout (this store) hides :not(.is-active) on desktop, so DOM order is irrelevant
  //   and prepending would just reshuffle the slider counter to 1
  // - mobile slider should scroll to the target's natural offset so the counter matches
  function applyTarget(targetMediaId) {
    const gallery = document.querySelector('media-gallery');
    if (!gallery || !originalSetActiveMedia) return;
    try {
      suppressSlideListener = true;
      originalSetActiveMedia.call(gallery, targetMediaId, false);
      setTimeout(() => { suppressSlideListener = false; }, 250);
    } catch (e) {
      log('applyTarget threw', e);
      suppressSlideListener = false;
    }
  }

  // Idempotent. Safe to call as often as we want — it no-ops when state already matches.
  // Only active inside the 3s restore window after a variant change, so it doesn't
  // override deliberate user actions later.
  function tryRestoreSlide() {
    if (Date.now() > restoreWindowExpiry) return;
    if (targetSlot == null || targetSlot <= 1) return;

    const slider = getMainSlider();
    if (!slider) return;

    const sorted = getSortedVisibleItems(slider);
    const targetItem = sorted[targetSlot - 1];
    if (!targetItem) {
      log('restore skip: slot out of bounds', { targetSlot, visibleCount: sorted.length });
      return;
    }

    if (targetItem.classList.contains('is-active')) return; // already correct

    const targetMediaId = targetItem.dataset.mediaId;
    if (!targetMediaId) return;

    log('RESTORE:', { targetMediaId, targetSlot, visibleCount: sorted.length });
    applyTarget(targetMediaId);
  }

  function applyFilter() {
    const variantId = getVariantId();
    if (!variantId) return;

    const range = variantRanges[variantId];

    document.querySelectorAll('media-gallery [data-media-id], product-modal [data-media-id]').forEach((el) => {
      const mid = extractMediaId(el.dataset.mediaId);
      if (!mid) return;
      if (!range) {
        el.classList.remove('vir-hidden');
      } else {
        const shouldHide = !isInRange(mid, range, variantId);
        // Don't yank vir-hidden onto whatever's currently .is-active. On desktop
        // thumbnail layout (:not(.is-active) { display:none }), hiding the active
        // item before Dawn moves .is-active to the new variant's featured leaves
        // an empty frame — visible as a brief flash. We re-run applyFilter from
        // the setActiveMedia hook once .is-active has moved, which cleans this up.
        if (shouldHide && el.classList.contains('is-active')) return;
        el.classList.toggle('vir-hidden', shouldHide);
      }
    });

    document.querySelectorAll('[data-target]').forEach((btn) => {
      const mid = extractMediaId(btn.dataset.target);
      if (!mid) return;
      const wrapper = btn.closest('li') || btn;
      if (!range) {
        wrapper.classList.remove('vir-hidden');
      } else {
        wrapper.classList.toggle('vir-hidden', !isInRange(mid, range, variantId));
      }
    });

    updateSliderUI();
  }

  function updateSliderUI() {
    document.querySelectorAll('slider-component').forEach((slider) => {
      const visibleItems = slider.querySelectorAll('li:not(.vir-hidden)');
      const visibleCount = visibleItems.length;

      const totalEl = slider.querySelector('.slider-counter--total');
      if (totalEl) totalEl.textContent = String(visibleCount);

      const buttons = slider.querySelector('.slider-buttons');
      if (buttons) {
        buttons.classList.toggle('vir-empty', visibleCount <= 1);
      }

      const isMobileSlider = slider.id && slider.id.startsWith('GalleryViewer-');
      const onMobile = window.matchMedia('(max-width: 749px)').matches;
      if (isMobileSlider && onMobile && typeof slider.initPages === 'function') {
        try { slider.initPages(); } catch (e) {}
      }

      // Thumbnail strip: Dawn's setActiveThumbnail scrolls the strip to the
      // active item's offsetLeft INSIDE setActiveMedia — but that runs before
      // applyFilter adds vir-hidden, so the offset is computed against a layout
      // that still includes the now-hidden variants. Re-align after hiding.
      const isThumbStrip = slider.id && slider.id.startsWith('GalleryThumbnails-');
      if (isThumbStrip) {
        const active = slider.querySelector('button[aria-current]')?.closest('li');
        if (active && slider.slider) {
          slider.slider.scrollLeft = active.offsetLeft;
        }
        if (typeof slider.initPages === 'function') {
          try { slider.initPages(); } catch (e) {}
        }
      }
    });
  }

  function hookSetActiveMedia() {
    const mediaGallery = document.querySelector('media-gallery');
    if (!mediaGallery || mediaGallery._virHooked) return;
    if (typeof mediaGallery.setActiveMedia !== 'function') return;

    originalSetActiveMedia = mediaGallery.setActiveMedia;
    mediaGallery._virHooked = true;

    const ourElement = mediaGallery;
    // Force prepend=false in the underlying call so the main gallery DOM (and
    // therefore the slider counter) isn't reshuffled. But then manually move
    // the active thumbnail to first-child of the thumbnail strip — the
    // hide_variants CSS rule (.thumbnail-list_item--variant:not(:first-child)
    // { display:none }) only shows the FIRST variant thumbnail, and without
    // this move the wrong variant's thumbnail stays in that slot.
    mediaGallery.setActiveMedia = function (mediaId /*, prepend */) {
      log('Dawn setActiveMedia', mediaId);
      const result = originalSetActiveMedia.call(ourElement, mediaId, false);

      const strip = ourElement.querySelector('slider-component[id^="GalleryThumbnails-"]');
      const activeThumb = strip && strip.querySelector(`[data-target="${mediaId}"]`);
      if (activeThumb && activeThumb.parentElement && activeThumb.parentElement.firstChild !== activeThumb) {
        activeThumb.parentElement.prepend(activeThumb);
      }

      // Now that .is-active has moved to the new variant's featured, run
      // applyFilter again so vir-hidden lands on the previously-active item
      // (which the earlier applyFilter intentionally skipped to avoid the flash).
      applyFilter();

      // Restore the user's saved slot SYNCHRONOUSLY. If we queued this via rAF,
      // the browser would paint the variant's featured image first and only
      // move to the saved slot one frame later — visible as a brief flash.
      tryRestoreSlide();

      return result;
    };
    log('Hooked setActiveMedia');
  }

  function attachSlideListener() {
    const slider = getMainSlider();
    if (!slider || slider._virSlideListener) return;
    slider._virSlideListener = true;
    slider.addEventListener('slideChanged', (e) => {
      if (suppressSlideListener) return;
      const onMobile = window.matchMedia('(max-width: 749px)').matches;
      if (!onMobile) return;
      if (!e.detail || e.detail.currentPage == null) return;

      const visibleDOMOrder = Array.from(slider.querySelectorAll('li:not(.vir-hidden)'));
      const currentItem = visibleDOMOrder[e.detail.currentPage - 1];
      if (!currentItem) return;
      const sorted = getSortedVisibleItems(slider);
      const newSlot = sorted.indexOf(currentItem) + 1;
      if (newSlot > 0) {
        targetSlot = newSlot;
        log('swipe: targetSlot=', targetSlot, '(currentPage=', e.detail.currentPage, ')');
      }
    });
  }

  // Warm the browser image cache for gallery images during idle time, so a
  // variant switch (which makes a previously display:none image visible) doesn't
  // show a brief white flash while the lazy-loaded src fetches. The DOM <img>s
  // keep loading="lazy" so Lighthouse's "Defer offscreen images" stays happy —
  // we just preload through a separate Image() that lands in the HTTP cache.
  function preloadGalleryImages() {
    const imgs = Array.from(
      document.querySelectorAll('media-gallery img[loading="lazy"], product-modal img[loading="lazy"]')
    );
    if (imgs.length === 0) return;

    let i = 0;
    const idle = window.requestIdleCallback || function (cb) { return setTimeout(() => cb({ timeRemaining: () => 50, didTimeout: false }), 500); };

    function next(deadline) {
      while (i < imgs.length && (deadline.timeRemaining() > 1 || deadline.didTimeout)) {
        const orig = imgs[i++];
        if (orig.complete && orig.naturalWidth > 0) {
          // Already loaded — still trigger decode so the pixels are cached, not
          // just the compressed bytes. Otherwise first display still flashes white.
          orig.decode && orig.decode().catch(() => {});
          continue;
        }
        const preloader = new Image();
        if (orig.sizes) preloader.sizes = orig.sizes;
        if (orig.srcset) preloader.srcset = orig.srcset;
        if (orig.src) preloader.src = orig.src;
        // Also decode through the preloader so decoded pixels land in the
        // browser's image cache before the real <img> ever needs them.
        preloader.decode && preloader.decode().catch(() => {});
      }
      if (i < imgs.length) idle(next, { timeout: 5000 });
    }
    idle(next, { timeout: 5000 });
  }

  function init() {
    applyFilter();
    hookSetActiveMedia();
    attachSlideListener();
    initTargetSlotFromActive();
    preloadGalleryImages();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // ---------- Thumbnail click (user intent) ----------
  document.addEventListener('click', (e) => {
    const thumbWrapper = e.target.closest('[data-target]');
    if (!thumbWrapper) return;
    if (!thumbWrapper.closest('slider-component[id^="GalleryThumbnails-"]')) return;
    const slider = getMainSlider();
    if (!slider) return;
    const targetId = thumbWrapper.dataset.target;
    const sorted = getSortedVisibleItems(slider);
    const targetItem = sorted.find((li) => li.dataset.mediaId === targetId);
    if (targetItem) {
      targetSlot = sorted.indexOf(targetItem) + 1;
      log('thumb click: targetSlot=', targetSlot);
    }
  }, true);

  // ---------- Variant change ----------
  document.addEventListener('change', (e) => {
    if (!e.target.closest('variant-radios, variant-selects, fieldset[data-section]')) return;

    initTargetSlotFromActive();
    restoreWindowExpiry = Date.now() + 3000;
    hookSetActiveMedia();
    attachSlideListener();
    requestAnimationFrame(applyFilter);
    // Trigger an immediate restore attempt too — covers the case where Dawn's
    // setActiveMedia fires very late or not at all (the broken sequence in the logs).
    requestAnimationFrame(() => requestAnimationFrame(tryRestoreSlide));
    log('variant change: targetSlot=', targetSlot);
  }, true);

  // ---------- URL / history changes ----------
  const wrap = (orig) => function (...args) {
    const result = orig.apply(this, args);
    requestAnimationFrame(applyFilter);
    return result;
  };
  history.pushState = wrap(history.pushState);
  history.replaceState = wrap(history.replaceState);

  // ---------- MutationObserver: re-hook, re-filter, re-check restore ----------
  const productInfo = document.querySelector('product-info');
  if (productInfo) {
    let t;
    new MutationObserver(() => {
      clearTimeout(t);
      t = setTimeout(() => {
        applyFilter();
        hookSetActiveMedia();
        attachSlideListener();
        tryRestoreSlide();
      }, 50);
    }).observe(productInfo, { childList: true, subtree: true });
  }
})();